import { styled } from '@mui/material/styles';

const StyledStatus = styled('span')`
  color: var(--success-color);
  font-size: 0.9rem;
  font-weight: bold;
  letter-spacing: 1px;
`;

export default StyledStatus;
